<app-navbar></app-navbar>

<!-- Loading Spinner -->
<div *ngIf="isLoading" class="loading-container fondo-cea">
  <h3 class="text-center texto-crema">
    <fa-icon [icon]="faSpinner" [spin]="true"></fa-icon>
    {{ 'Loading' | translate }}
  </h3>
</div>
<section class="container">
<!-- Hero Section -->
<div *ngIf="!isLoading" class="hero-section fondo-cea">
  <div class="">
    <div class="hero-content">
      <span class="hero-tag-cea">DOWNLOADS</span>
      <h1 class="hero-title-cea">Technical resources</h1>
      <p class="hero-subtitle-cea">Find all the product datasheets, manuals, and technical documentation you need in one place.</p>
    </div>
  </div>
</div>

<!-- Products Section -->
<div *ngIf="!isLoading" class="products-section fondo-cea">
  <div class="">
    
    <!-- Loop por cada empresa -->
    <div *ngFor="let empresa of empresas" class="empresa-group-cea">
      <h2 class="empresa-title-cea">{{ empresa }}</h2>
      
      <div class="row productos-grid">
        <!-- Loop por cada producto de la empresa -->
        <div *ngFor="let producto of productosPorEmpresa[empresa]" 
             class="col-lg-3 col-md-4 col-sm-6 producto-col">
          
          <div class="producto-card-cea">
            <!-- Imagen del producto -->
            <div class="producto-image-container-cea">
              <img [src]="'https://cms.eft-systems.de/' + producto.img" 
                   [alt]="producto.name1" 
                   class="producto-image-cea">
            </div>
            
            <!-- Nombre del producto -->
            <h3 class="producto-name-cea">{{ producto.name1 | translate }}</h3>
            
            <!-- Categorías -->
            <ng-container *ngIf="getCategoriasProducto(producto.name1) as categorias">
            <div *ngIf="categorias.length > 0; else sinDocsTemplate" class="categorias-list-cea">
                <div *ngFor="let cat of categorias" class="categoria-item-cea">
                  <div *ngIf="cat.name !== 'Subsidy Form'" 
                       class="categoria-header-cea" 
                       (click)="toggleCollapse(producto.name1 + '_' + cat.name, producto.name1, cat.name, $event)">
                    
                    <div class="categoria-header-content-cea">
                      <span class="categoria-icon-cea">
                        <i class="fas" 
                           [ngClass]="{'fa-chevron-down': collapsed[producto.name1 + '_' + cat.name], 
                                       'fa-chevron-up': !collapsed[producto.name1 + '_' + cat.name]}"></i>
                      </span>
                      <span class="categoria-name-cea">{{ cat.name | translate }}</span>
                      
                      <span *ngIf="isLoadingCategoria(producto.name1, cat.name)" 
                            class="loading-spinner-cea">
                        <fa-icon [icon]="faSpinner" [spin]="true"></fa-icon>
                      </span>
                    </div>
                  </div>
                  
                  <!-- Documentos de la categoría -->
                  <div *ngIf="!collapsed[producto.name1 + '_' + cat.name]" 
                       class="categoria-documentos-cea">
                    
                    <!-- Mensaje si no hay documentos -->
                    <div *ngIf="sinDocumentosCategoria(producto.name1, cat.name) && !isLoadingCategoria(producto.name1, cat.name)" 
                         class="alert alert-warning" 
                         [innerHTML]="'No hay documentos disponibles en esta categoría.'|translate">
                    </div>
                    
                    <!-- Lista de documentos -->
                    <div *ngFor="let doc of getDocumentosDeCategoria(producto.name1, cat.name)" class="documento-item-cea">
                      <ng-container *ngIf="!isLoadingCategoria(producto.name1, cat.name) && !sinDocumentosCategoria(producto.name1, cat.name)">
                        <a *ngIf="!doc.file.includes('https')" 
                           href="https://cms.eft-systems.de/{{ doc.file }}" 
                           target="_blank" 
                           class="documento-link-cea">
                          {{ doc.title }}
                        </a>
                        <a *ngIf="doc.file.includes('https')" 
                           href="{{ doc.file }}" 
                           target="_blank" 
                           class="documento-link-cea">
                          {{ doc.title }}
                        </a>
                      </ng-container>
                    </div>
                  </div>
                </div>
            </div>
            <ng-template #sinDocsTemplate>
              <div class="sin-documentos-cea">
                {{ 'No hay documentos disponibles en esta categoría.' | translate }}
              </div>
            </ng-template>
            </ng-container>
           
          </div>
        </div>
      </div>
    </div>
    
  </div>
</div>
</section>
<app-footer></app-footer>
